import { Modal, Descriptions } from "antd";

const ViewBankDetailsModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  bankDetails = {}
}) => {
  return (
    <Modal
      title="Bank Details"
      centered
      width={"100em"}
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setIsModalOpen(false);
      }}
    >
      <Descriptions
        style={{ marginBottom: "30px" }}
        title="Bank Details"
        bordered
        column={{ xs: 1, sm: 2 }}
      >
        <Descriptions.Item label="Account Holder Name">
          {bankDetails?.accountHolderName}
        </Descriptions.Item>
        <Descriptions.Item label="Account Number">{bankDetails?.accountNumber}</Descriptions.Item>
        <Descriptions.Item label="IFSC Code">{bankDetails?.IFSCCode}</Descriptions.Item>
        <Descriptions.Item label="Bank name">{bankDetails?.bankName}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default ViewBankDetailsModal;
